import { BizAdAccount } from '@kakao/mfa-container'
import { useHistory } from 'react-router-dom'
import useWhiteBackground from 'features/crux/mfa/hooks/useWhiteBackground'
import useObserver from 'features/crux/mfa/hooks/useObserver'
import { AD_PLATFORM_TYPE, CRUX_PHASE } from '../cruxConstants'
import { useCallback } from 'react'

const BizAdAccountApp = () => {
  useWhiteBackground()
  const history = useHistory()
  const observer = useObserver()
  const gotoDashboard = useCallback(
    adAccountId => {
      history.push(`/${adAccountId}/dashboard`)
    },
    [history]
  )
  const gotoNewCampaign = useCallback(
    adAccountId => {
      history.push(`/${adAccountId}/ads/campaigns/new`)
    },
    [history]
  )
  const gotoTracker = useCallback(
    adAccountId => {
      history.push(`/${adAccountId}/tracker`)
    },
    [history]
  )
  const gotoAdAccountList = useCallback(
    () => history.push('/adaccount/all'),
    [history]
  )
  return (
    <BizAdAccount
      phase={CRUX_PHASE}
      adPlatformType={AD_PLATFORM_TYPE}
      basePath="/adaccount/all"
      observer={observer}
      onAdAccountClick={gotoDashboard}
      onGoToDashboardClick={gotoDashboard}
      onLinkagePixelClick={gotoTracker}
      onCreateAdClick={gotoNewCampaign}
      onGoToListClick={gotoAdAccountList}
    />
  )
}
export default BizAdAccountApp
